import { useState, useCallback } from 'preact/hooks'
import { useTranslation } from 'react-i18next'

interface UseSummaryConsentReturn {
  isAccepted: boolean
  consentError: string | null
  setIsAccepted: (value: boolean) => void
  validateConsent: () => boolean
  clearConsentError: () => void
}

/**
 * Hook for managing user consent checkbox state and validation
 * Handles acceptance state, error messages, and validation logic
 */
export function useSummaryConsent(): UseSummaryConsentReturn {
  const { t } = useTranslation()
  const [isAccepted, setIsAccepted] = useState(false)
  const [consentError, setConsentError] = useState<string | null>(null)

  const validateConsent = useCallback(() => {
    if (!isAccepted) {
      setConsentError(t('documentAdd.checkboxes.consentRequired'))
      return false
    }
    return true
  }, [isAccepted, t])

  const clearConsentError = useCallback(() => {
    setConsentError(null)
  }, [])

  return {
    isAccepted,
    consentError,
    setIsAccepted,
    validateConsent,
    clearConsentError,
  }
}
